export const SESSION_KEY = "startedSignIn";
